import { datadogRum } from '@datadog/browser-rum';

export const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  enabled,
  env,
}: {
  applicationId: string;
  clientToken: string;
  service: string;
  enabled: boolean;
  env: string;
}) => {
  if (!enabled) {
    return;
  }
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
};
